import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import { useLocalStorage } from '@vueuse/core';
import { useSupportMessageStore } from '#modules/support/stores/support-message.store.js';

export const useSupportStore = defineStore('support', () => {
    const supportMessageStore = useSupportMessageStore();

    const onlyPersonalTickets = useLocalStorage('onlyPersonalTickets', false);
    const onlyOpenTickets = useLocalStorage('onlyOpenTickets', false);
    const searchQuery = ref('');
    const sort = useLocalStorage('supportStoreTicketsSort', '-updated_at');

    const hasEnabledFilters = computed(() => {
        return onlyPersonalTickets.value || onlyOpenTickets.value || searchQuery.value !== '';
    });

    const activeTicket = computed(() => supportMessageStore.supportMessage);

    const setActiveTicket = (ticket) => {
        supportMessageStore.setActiveSupportMessage(ticket);
    };

    const isActiveTicket = (ticket) => {
        return Boolean(activeTicket.value && activeTicket.value.id === ticket.id);
    };

    const resetFilters = () => {
        searchQuery.value = '';
        onlyPersonalTickets.value = false;
        onlyOpenTickets.value = false;
    };

    const dehydrate = () => {
        searchQuery.value = '';
    };

    return {
        onlyPersonalTickets,
        onlyOpenTickets,
        searchQuery,
        sort,
        hasEnabledFilters,
        activeTicket,
        setActiveTicket,
        isActiveTicket,
        resetFilters,
        dehydrate,
    };
});
